<template>
  <div class="form tab-content">
    <v-layout row>
      <v-btn
        x-small
        color="accent"
        :disabled="readOnly"
        class="ml-3 mb-2"
        @click="makeEverythingCorrect"
      >
        <v-icon left>thumb_up_alt</v-icon>
        {{ $t("EverythingIsCorrect") }}
      </v-btn>
    </v-layout>

    <v-layout row style="width: 100%">
      <v-flex xs7>
        <div class="input-field" style="width: 100%;text-transform: uppercase">
          {{ $t("Environment") }}
        </div>
        <input-field
          :value="objectData.environment"
          label=""
          input-type="other"
          size="large"
          :field-disabled="readOnly"
        >
          <v-layout column>
            <v-checkbox
              :input-value="
                getValueInObject('tp_pe_implanted_in_private_property')
              "
              @change="
                updateValue('tp_pe_implanted_in_private_property', $event)
              "
              :label="$t('ImplantedPrivateProperty')"
              :disabled="readOnly"
              color="accent"
              :ripple="false"
            />
            <v-checkbox
              :input-value="getValueInObject('tp_pe_problematic_overhang')"
              @change="updateValue('tp_pe_problematic_overhang', $event)"
              :label="$t('ProblematicOverhang')"
              :disabled="readOnly"
              color="accent"
              :ripple="false"
            />
            <v-checkbox
              :input-value="getValueInObject('tp_pe_pruning_required')"
              @change="updateValue('tp_pe_pruning_required', $event)"
              :label="$t('PruningRequired')"
              :disabled="readOnly"
              color="accent"
              :ripple="false"
            />
            <v-checkbox
              :input-value="
                getValueInObject('tp_pe_installed_bitumen_tarmac_cobblestone')
              "
              @change="
                updateValue(
                  'tp_pe_installed_bitumen_tarmac_cobblestone',
                  $event
                )
              "
              :label="$t('InstalledBitumenTarmacCobblestone')"
              :disabled="readOnly"
              color="accent"
              :ripple="false"
            />
            <v-checkbox
              :input-value="getValueInObject('tp_pe_accessible_with_vehicle')"
              @change="updateValue('tp_pe_accessible_with_vehicle', $event)"
              :label="$t('AccessibleWithVehicle')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
          </v-layout>
        </input-field>
      </v-flex>
      <v-flex xs5>
        <photo-field
          :disabled="disabled"
          :image-data="environmentPhoto"
          :previousPhoto="getPhoto(environmentPhoto.varName)"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="removePhoto($event)"
        />
      </v-flex>
    </v-layout>

    <v-layout row style="width: 100%">
      <v-flex xs7>
        <div class="input-field" style="width: 100%;text-transform: uppercase">
          {{ $t("Safety") }}
        </div>
        <input-field
          :value="objectData.safety"
          label=""
          input-type="other"
          size="large"
          :field-disabled="readOnly"
        >
          <v-layout column>
            <v-checkbox
              :input-value="getValueInObject('tp_pe_buckling_control_ok')"
              @change="updateValue('tp_pe_buckling_control_ok', $event)"
              :label="$t('BucklingControlOK')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              :input-value="getValueInObject('tp_pe_vertical_control_ok')"
              @change="updateValue('tp_pe_vertical_control_ok', $event)"
              :label="$t('VerticalityControlOK')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="
                getValueInObject('tp_pe_respects_neighboring_light_fixture')
              "
              @change="
                updateValue('tp_pe_respects_neighboring_light_fixture', $event)
              "
              :label="$t('RespectsNeighboringLightFixture')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="getValueInObject('tp_pe_yellow_label_absent')"
              @change="updateValue('tp_pe_yellow_label_absent', $event)"
              :label="$t('YellowLabelAbsent')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="getValueInObject('tp_pe_usable_pole_head')"
              @change="updateValue('tp_pe_usable_pole_head', $event)"
              :label="$t('UsablePoleHead')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
          </v-layout>
        </input-field>
      </v-flex>
      <v-flex xs5>
        <photo-field
          :disabled="disabled"
          :image-data="safetyPhoto"
          :previousPhoto="getPhoto(safetyPhoto.varName)"
          @updatePhoto="updatePhoto($event)"
          @removePhoto="removePhoto($event)"
        />
      </v-flex>
    </v-layout>

    <v-layout row style="width: 100%">
      <v-flex xs6>
        <div class="input-field" style="width: 100%;text-transform: uppercase">
          {{ $tc("TestNoun", 2) }}
        </div>
        <input-field
          :value="objectData.tests"
          label=""
          input-type="other"
          size="large"
          :field-disabled="readOnly"
        >
          <v-layout column>
            <v-checkbox
              :input-value="getValueInObject('tp_pe_visual_ok')"
              @change="updateValue('tp_pe_visual_ok', $event)"
              :label="$t('Visual') + ' OK'"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="getValueInObject('tp_pe_percussion_ok')"
              @change="updateValue('tp_pe_percussion_ok', $event)"
              :label="$t('Percussion') + ' OK'"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="getValueInObject('tp_pe_shake_ok')"
              @change="updateValue('tp_pe_shake_ok', $event)"
              :label="$t('Shake') + ' OK'"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              v-if="isTelecom"
              :input-value="getValueInObject('tp_pe_square_tip_ok')"
              @change="updateValue('tp_pe_square_tip_ok', $event)"
              :label="$t('SquareTip') + ' OK'"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
          </v-layout>
        </input-field>
      </v-flex>

      <v-flex xs6 v-if="isTelecom">
        <div class="input-field" style="width: 100%;text-transform: uppercase">
          {{ $tc("Pole", 1) }}
        </div>
        <input-field
          :value="objectData.pole"
          label=""
          input-type="other"
          size="large"
          :field-disabled="readOnly"
        >
          <v-layout column>
            <v-checkbox
              :input-value="getValueInObject('tp_pe_pole_head_refitting')"
              @change="updateValue('tp_pe_pole_head_refitting', $event)"
              :label="$t('PoleHeadRefitting')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              :input-value="
                getValueInObject('tp_pe_pole_recalibration_relocation')
              "
              @change="
                updateValue('tp_pe_pole_recalibration_relocation', $event)
              "
              :label="$t('PoleRecalibrationRelocation')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
            <v-checkbox
              :input-value="getValueInObject('tp_pe_pole_replacement')"
              @change="updateValue('tp_pe_pole_replacement', $event)"
              :label="$t('PoleReplacement')"
              :disabled="readOnly"
              color="#4fa2b7"
              :ripple="false"
            />
          </v-layout>
        </input-field>
      </v-flex>
    </v-layout>

    <input-field
      v-if="isTelecom"
      :value="getValueInObject('tp_pe_detail_works_to_perform')"
      @input="updateValue('tp_pe_detail_works_to_perform', $event)"
      :label="$t('DetailWorksToPerform')"
      size="large"
      inputType="textarea"
      :fieldDisabled="readOnly"
    />
  </div>
</template>

<script>
import { poleEffortModuleTabsMixin } from "../../../../../mixins/forms/poleEffortTabsMixin";
import InputField from "../../_Molecules/InputField";
import PhotoField from "../Photos/PhotoField";

export default {
  name: "PoleTerrainTab",

  components: { PhotoField, InputField },

  mixins: [poleEffortModuleTabsMixin],

  props: {
    previousImages: {
      type: Array
    }
  },

  data() {
    return {
      everythingIsCorrect: false,
      everythingIsCorrectVariables: [
        { varName: "tp_pe_implanted_in_private_property", value: false },
        { varName: "tp_pe_problematic_overhang", value: false },
        { varName: "tp_pe_pruning_required", value: false },
        { varName: "tp_pe_installed_bitumen_tarmac_cobblestone", value: false },
        { varName: "tp_pe_accessible_with_vehicle", value: true },
        { varName: "tp_pe_buckling_control_ok", value: true },
        { varName: "tp_pe_vertical_control_ok", value: true },
        { varName: "tp_pe_visual_ok", value: true }
      ],
      everythingIsCorrectTelecomVariables: [
        { varName: "tp_pe_respects_neighboring_light_fixture", value: true },
        { varName: "tp_pe_yellow_label_absent", value: true },
        { varName: "tp_pe_usable_pole_head", value: true },

        { varName: "tp_pe_visual_ok", value: true },
        { varName: "tp_pe_percussion_ok", value: true },
        { varName: "tp_pe_shake_ok", value: true },
        { varName: "tp_pe_square_tip_ok", value: true },

        { varName: "tp_pe_pole_head_refitting", value: false },
        { varName: "tp_pe_pole_recalibration_relocation", value: false },
        { varName: "tp_pe_pole_replacement", value: false }
      ]
    };
  },

  computed: {
    environmentPhoto() {
      return {
        label: this.$i18n.t("Environment"),
        varName: "photoEnvironment"
      };
    },
    safetyPhoto() {
      return {
        label: this.$i18n.t("Safety"),
        varName: "photoSafety"
      };
    }
  },

  methods: {
    getPhoto(imageName) {
      return this.previousImages.find(image => {
        return image.name === imageName;
      });
    },
    updatePhoto(photo) {
      this.$emit("updatePhoto", photo);
    },
    removePhoto(photo) {
      this.$emit("removePhoto", photo);
    },

    makeEverythingCorrect() {
      this.everythingIsCorrectVariables.forEach(variable => {
        this.updateValue(variable.varName, variable.value);
      });
      if (this.isTelecom) {
        this.everythingIsCorrectTelecomVariables.forEach(variable => {
          this.updateValue(variable.varName, variable.value);
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/PoleEffortModule/TerrainTab.vue